import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Registry } from '@/registry.service';
import { DialogPopUpComponent } from '@components/dialog-pop-up/dialog-pop-up.component';
import { LoggerService } from '@services/logger.service';
import { Component, OnInit } from '@angular/core';
import { ButtonComponent } from '@components/button/button.component';
import { PracticesService } from '@services/practices.service';
import { ToastrService } from 'ngx-toastr';
import { UsedVehicleModel } from '@/models/usedVehicleModel';

@Component({
  selector: 'app-button-exchange-delete',
  templateUrl: '../button.component.html',
  styleUrls: ['../button.component.scss'],
})
export class ButtonDeleteExchangeComponent extends ButtonComponent implements OnInit {
  faIcon = faTrashCan;
  private exchange: UsedVehicleModel;
  private rowData: any;

  constructor(
    protected router: Router,
    public dialog: MatDialog,
    private practicesService: PracticesService,
    protected toastr: ToastrService,
  ) {
    super(router, toastr);

    this.color = 'danger';
    this.additionalClass = 'py-0.5 px-2.5';
    this.showIcon = true;
    this.smallBtn = true;
  }

  ngOnInit() {
    this.exchange = <UsedVehicleModel>this.rowData;
  }

  /**
   * Delete user
   */
  public actionClick(): void {
    let dialogRef = this.dialog.open(DialogPopUpComponent, {
      width: 'auto',
      panelClass: 'custom-modalbox',
    });

    this.setupPopup(dialogRef);

    dialogRef.afterClosed().subscribe((deleteExchange) => {
      if (deleteExchange) {
        this.practicesService.deleteExchange(this.exchange.id).subscribe({
          next: () => {
            this.toastr.success('Permuta cancellata correttamente!');

            Registry.getInstance().get('PracticeDetailsComponent').refreshExchange();
          },
          error: (error) => {
            LoggerService.error('deleteExchange failed!');
            LoggerService.error(error);

            this.toastr.error(`Errore durante la cancellazione della permuta.`);
          },
          complete: () => {
            LoggerService.log('Request done');
          },
        });
      }
    });
  }

  private setupPopup(dialogRef: MatDialogRef<DialogPopUpComponent>) {
    dialogRef.componentInstance.title = 'Confermi di voler cancellare questa permuta?';
    dialogRef.componentInstance.content =
      'Attenzione una volta cancellata la permuta non sarà più possibile recuperarla.';
    dialogRef.componentInstance.firstCTA = 'Si cancella';
    dialogRef.componentInstance.secondCTA = 'Annulla operazione';
    dialogRef.componentInstance.closeResultFirst = true;
    dialogRef.componentInstance.closeResultSecond = false;
  }
}
